import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import { translate } from 'react-i18next';
import Checkbox from 'antd/lib/checkbox';
import { selectNotifications, changeNotificationsActions } from '../../../features/auth/ducks';
import { accountRoles } from '../../../common/enums';

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 14,
      offset: 6,
    },
    sm: {
      span: 14,
      offset: 6,
    },
  },
};

const formItemLayout = {
  labelCol: {
    xs: {
      span: 9,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 15,
    },
    sm: {
      span: 14,
    },
  },
};

const mapStateToProps = state => ({
  notifications: selectNotifications(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      onChangeNotifications: changeNotificationsActions.request
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
@Form.create()
export default class NotificationSettings extends Component {
  static propTyes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
  };

  handleSubmitPassword = e => {
    e.preventDefault();

    const { form, actions, account } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        actions.onChangeNotifications({ accountId: account.id, notifications: values.notifications });
      }
    });
  };

  render() {
    const { form, t, notifications, account } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Spin spinning={false}>
        {notifications && 
          <Form onSubmit={this.handleSubmitPassword}>

            <Form.Item {...tailFormItemLayout}>
              <h3>{t('Notifikácie')}</h3>
            </Form.Item>

            {account.role === accountRoles.CREDITOR &&
              <Form.Item {...formItemLayout} label={t('Nové investičné príležitosti')}>
                {getFieldDecorator('notifications.newInvestmentOpportunities', {
                  initialValue: notifications.newInvestmentOpportunities,
                })(<Checkbox defaultChecked={notifications.newInvestmentOpportunities} />)}
              </Form.Item>
            }

            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit" size="small">
                {t('Odoslať')}
              </Button>
            </Form.Item>
          </Form>
        }
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-settings/components/NotificationSettings.js